<template>
  <div>
    <div class="text-xl 2xl:text-2xl font-title font-semibold text-ocean-900">
      Are you concerned?
    </div>
    <div class="vetster-prose text-neutral-900 mt-2">
      <p>Connect with a vet to get more information about your pet’s health.</p>
    </div>
    <vetster-button
      v-cloak
      class="mt-4"
      :href="guidedSearchUrl"
      rel="nofollow"
      variant="white"
      size="xl"
    >
      <fa
        :icon="['fas', 'search']"
        class="text-xl mr-2"
      />
      <span class="whitespace-no-wrap text-center">
        Book an online vet
      </span>
    </vetster-button>
  </div>
</template>

<script>
import LocalizesRoutes from '@/mixins/LocalizesRoutes';

export default {
  name: 'VetsterEditorialModuleAreYouConcerned',

  mixins: [LocalizesRoutes],
};
</script>
